import { useEffect,useState } from "react";

import { apiRequest } from "../../network/apiClient";
import { API_ENDPOINTS } from "../apiEndpoints";

export const useLeadInventoryYours = (page, pageSize, selectedStatus, filters, searchName, selectedPipelineStage) => {
    const [data, setData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [totalLeads, setTotalLeads] = useState(0);
    const [leadStatusCount, setLeadStatusCount] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [absoluteTotal, setAbsoluteTotal] = useState(0);
    const [pipelineStageCount, setPipelineStageCount] = useState([]);
    const leadStatuses = [];
    const pipelineStages = [];

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                const queryParams = new URLSearchParams({
                    page: page.toString(),
                    page_size: pageSize.toString(),
                })
                // Add filters to the query parameters
                // Handle lead status selection 
                if(selectedStatus) {
                    leadStatuses.push(selectedStatus)
                }
                if (filters?.leadStatus?.length) {
                    leadStatuses.push(...filters.leadStatus)
                }
                leadStatuses.forEach(status => {
                    queryParams.append("lead_status", status);
                });
                // Handle name search
                if(searchName){
                    queryParams.append("name", searchName);
                    console.log(queryParams);
                }
                // Handle product selection
                if (filters?.products?.length) {
                    filters.products.forEach(product => {
                        queryParams.append("products", product);
                    });
                }
                // Handle pipeline stage (status) selection
                if (selectedPipelineStage) {
                    if(Array.isArray(selectedPipelineStage)){
                        if(selectedPipelineStage.length === 1){
                            pipelineStages.push(selectedPipelineStage[0])
                        }else{
                            pipelineStages.push(...selectedPipelineStage)
                        }
                    } else {
                        pipelineStages.push(selectedPipelineStage)
                    }
                }
                if (filters?.pipelineStage?.length) {
                    pipelineStages.push(...filters.pipelineStage)
                }
                
                // Default: Select all pipeline stages except 'Activated' (stage 5)
                // if no pipeline stage is explicitly selected
                if (pipelineStages.length === 0) {
                    pipelineStages.push(0, 1, 2, 3, 4, 5, 6); // All stages except 5 (Activated)
                }
                
                pipelineStages.forEach(stage => {
                    queryParams.append("status", stage);
                });
                // Handle lead source selection
                if (filters?.leadSource?.length) {
                    filters.leadSource.forEach(source => {
                        queryParams.append("lead_source", source);
                    });
                }
                // Handle interest level selection
                if (filters?.interestLevel?.length) {
                    filters.interestLevel.forEach(level => {
                        queryParams.append("interest_level", level);
                    });
                }
                // Handle region selection
                if (filters?.region?.length) {
                    filters.region.forEach(region => {
                        queryParams.append("region", region);
                    });
                }

                const result = await apiRequest(`${API_ENDPOINTS.GET_LEADS.YOURS_INVENTORY}?${queryParams.toString()}`, 'GET');

                // Assign data to state
                if(result) {
                    setData(result.data);
                    setTotalPages(result.total_pages);
                    setTotalLeads(result.total_rows);
                    setLeadStatusCount(result.lead_status_count);
                    setAbsoluteTotal(result.absolute_total);
                    setPipelineStageCount(result.pipeline_stage_count);
                }else{
                    console.error("Failed to fetch lead inventory:", result.error);
                }
                setIsLoading(false);
            } catch (error) {
                setIsLoading(false);
            }
        };        
        fetchData();
    }, [page, pageSize, selectedStatus, filters, searchName, selectedPipelineStage]);

    return { data, totalPages, totalLeads, leadStatusCount, isLoading, absoluteTotal, pipelineStageCount };
};
